import Attendee from '../dto/Attendee';
import Error from '../model/Error';
import axios from 'axios';

export default class AttendeesRepository {
    static findAll(appointmentSeriesId, startDateTime) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/appointments/${appointmentSeriesId}/${startDateTime}/attendees`)
                .then((response) => resolve(response.data.data.map((data) => Attendee.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static createAttendee(attendee) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/appointments/${attendee.appointmentSeriesId}/${attendee.start}/attendees`, attendee.serialize())
                .then((response) => resolve(response.headers['x-identifier']))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static updateAttendee(attendee) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/attendees/${attendee.id}`, attendee.serialize())
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
